/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Entry from './Entry/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaIconExternalLink from 'DesignSystem/Svgs/TysiaIconExternalLink/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/PaymentOverdue/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let paymentOverdueValueData = fromData.useDataValue({ viewPath,
context: 'payment_overdue',
})
  return (<React.Fragment
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 onClick={onClick}
 height="auto"
 width="100%"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Payment Overdue"
 color={dtColorsNeutral500}
 weight="medium"
 size="normal"
/>
<TysiaIconExternalLink
  viewPath={`${viewPath}/TysiaIconExternalLink`}
 marginLeft="auto"
/>
</div>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(paymentOverdueValueData) && paymentOverdueValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="entry"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Entry(${item?.id ?? item?._id ?? index})`}
      >
<Entry
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Entry(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
)}
</TysiaButton>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }